'use client';

import React from 'react';
import { slugify } from '@/lib/utils/slug';
import { useRouter } from 'next/navigation';

interface BlogPostTagsProps {
  tags: string[];
}

export default function BlogPostTags({ tags }: BlogPostTagsProps) {
  const router = useRouter();

  if (!tags?.length) return null;

  return (
    <div className="flex items-center gap-2 mt-2">
      {tags.map((tag: string) => (
        <button
          key={tag}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();

            // Navigasi ke halaman tag
            router.push(`/blog/tag/${slugify(tag)}`);
          }}
          // className="px-1.5 py-1 text-xs rounded-lg md:text-sm transition-all duration-300 tracking-widefont-medium text-[#9e9e9e] border-emerald-500 bg-neutral-800 hover:bg-emerald-500/20 hover:text-emerald-300 cursor-pointer"
          className="px-1.5 py-1 text-xs rounded-lg md:text-sm transition-all duration-300 tracking-widefont-medium bg-[#1a1a1a] text-neutral-400 hover:text-neutral-300 hover:bg-[#252525] cursor-pointer"
        >
          #{tag}
        </button>
      ))}
    </div>
  );
}
